import NotificationMenu from './NotificationMenu.vue';

// @ts-ignore
NotificationMenu.install = (Vue) => {
  Vue.component((NotificationMenu as any).options.name, NotificationMenu);
};

export default NotificationMenu;
